import React from "react";
import styled from "styled-components";
import { withTheme } from "@material-ui/styles";
import { grey } from "@material-ui/core/colors";

import { responsiveThemeGrid } from "../layout/Grid";

const Wrapper = withTheme(styled.div`
  ${responsiveThemeGrid}
  margin: 10px 0;
`);

const Item = styled.div`
  width: 200px;
  height: 1.5rem;
  margin: 5px;
  background-color: ${grey[300]};
  border-radius: 5px;
`;

const AccessoryCheckBoxesSkeleton = () => (
  <Wrapper>
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
  </Wrapper>
);

export default AccessoryCheckBoxesSkeleton;
